import React, { useContext, useEffect, useState } from 'react';

import FireDataContext from '../../../services/firebase/FireDataContext';
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { keyGen } from '../../../services/keygen';
import Spacer from '../../../app/common/ui/Spacer';
import MemberMiniMenu from '../menus/MemberMiniMenu';
import MuiSwitch from '../../../app/common/ui/MuiSwitch';
import dayjs from 'dayjs';
import AuthContext from '../../../services/firebase/AuthContext';
import { onLocalHost } from '../../../app/common/useful';
import Button from '@material-ui/core/Button'

const MemberPage = ({ intermediaryId }) => {
    const db = useContext(FireDataContext);
    const { currentUser } = useContext(AuthContext);
    const [member, setMember] = useState();
    const [user, setUser] = useState();

    useEffect(() => {
        const unsubscribe = db.subscribe({
            path: `intermediaries/${intermediaryId}`,
            hook: data => {
                setMember(data);
            }
            , context: 'MemberPage'
        });

        db.get({ path: `users/${intermediaryId}`, context: 'MemberPage' })
            .then(setUser)
            .catch(error => console.log(error));

        return unsubscribe;
    }, [db, intermediaryId]);

    const handleLogRocketChange = useLogRocket => {
        console.log('handleLogRocketChange', useLogRocket)
        db.update({
            path: `users/${intermediaryId}`,
            payload: {
                useLogRocket
            },
            context: 'MemberPage'
        })
    }

    const toggleAdminRights = enableAdmin => {

        let { roles = [] } = user || {};

        if (!roles.includes('admin') && enableAdmin) {
            roles.push('admin');
        }
        else if (roles.includes('admin') && !enableAdmin) {
            roles = roles.filter(role => role !== 'admin');
        }

        db.update({
            path: `users/${intermediaryId}`,
            payload: {
                roles
            },
            context: '5e416666-7da0-429c-a6d7-c88f52ce5c4a'
        })
            .then(() => {
                setUser({ ...user, roles: [...roles] })
            })
            .catch(error => console.log(error));

    }


    if (!member) return <></>;

    const { profile, experience, preferences, unavailable } = member;

    const homeLocation = preferences?.location?.city ?? { name: 'Unknown', postcode: 'Unknown' };

    return (
        <MemberMiniMenu>
            <div>
                <Typography variant="h5" color="initial">{profile?.title}</Typography>
                <Grid container spacing={2} >
                    <Grid item><Typography variant="h6" color="textSecondary">{profile?.email}</Typography></Grid>
                    <Grid item><Typography variant="h6" color="textSecondary">{profile?.phoneNumber}</Typography></Grid>
                </Grid>

                <Typography variant="h6" color="initial">Summary</Typography>
                <Typography variant="body2">{profile?.summary}</Typography>
                <Spacer />
                <Typography variant="h6" color="initial">Home Location</Typography>
                <Grid container spacing={2}>
                    <Grid item>
                        <Typography variant="body2">{homeLocation.postcode}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2">{homeLocation.name}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2">Travel Distance {preferences?.location?.maxTravelDistance || 'Unknown'}</Typography>
                    </Grid>

                </Grid>
                <Spacer />
                <Typography variant="h6" color="initial">Preferred Locations</Typography>
                <Typography variant="body2" color="initial">{preferences?.likedLocations?.map(l => l.name)?.join(', ')}</Typography>
                <Spacer />
                <Typography variant="h6" color="initial">Excluded Locations</Typography>
                <Typography variant="body2" color="initial">{preferences?.dislikedLocations?.map(l => l.name)?.join(', ')}</Typography>
                <Spacer />
                <Typography variant="h6" color="initial">Unavailable Dates</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={1}>
                        <Typography variant="subtitle2">Description</Typography>
                    </Grid>
                    <Grid item xs={1}>
                        <Typography variant="subtitle2">From</Typography>
                    </Grid>
                    <Grid item xs={1}>
                        <Typography variant="subtitle2">Until</Typography>
                    </Grid>
                </Grid>
                {
                    unavailable?.map(u => {
                        return <div key={keyGen(5)}>
                            <Grid container spacing={2}>
                                <Grid item xs={1}>
                                    <Typography variant="body2">{u.description}</Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">{dayjs(u.dateConstraint.values[0]).format('ddd DD MMM YYYY')}</Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">{u.dateConstraint?.type === 'dateRange' ? dayjs(u.dateConstraint.values[1]).format('ddd DD MMM YYYY') : ''}</Typography>
                                </Grid>
                            </Grid>
                        </div>;
                    })
                }
                <Spacer />
                <Typography variant="h6" color="initial">Education</Typography>
                {
                    profile?.education?.map(({ course, institution, year }) => {
                        return (
                            <Typography variant="body2" key={keyGen(4)} >{course}, {institution}, {year}</Typography>
                        )
                    })
                }
                <Spacer />
                <Typography variant="h6" color="initial">Training</Typography>
                {
                    profile?.training?.map(({ course, institution, year }) => {
                        return (
                            <Typography variant="body2" key={keyGen(4)} >{course}, {institution}, {year}</Typography>
                        )
                    })
                }
                <Spacer />
                <Typography variant="h6" color="initial">Expertise</Typography>
                {
                    experience?.map(({ description }) => {
                        return (
                            <Typography variant="body2" key={keyGen(4)} >{description}</Typography>
                        )
                    })
                }
                <Spacer />
                <Typography variant="body2" key={keyGen(4)} >Slack ID: {member.slack?.id || 'Unknown'}</Typography>
                <Spacer />
                {
                    currentUser?.roles.includes('admin') && user &&
                    <MuiSwitch value={user.useLogRocket} label="Enable LogRocket Tracking" onChange={handleLogRocketChange} />
                }
                <Spacer />
                {
                    currentUser?.roles.includes('superuser') && user &&
                    <MuiSwitch value={user.roles.includes('admin')} label="Enable Admin Rights" onChange={toggleAdminRights} />
                }
                <Spacer />
                {
                    currentUser?.roles.includes('superuser') && user && onLocalHost() &&
                    <Button variant="outlined" color="primary" onClick={() => localStorage.setItem('2e6a2b671bf7', user.uid)}>
                      sudo
                    </Button>
                }

            </div>

        </MemberMiniMenu>
    );
};

export default MemberPage;